/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DebtType } from './DebtType';
import {
    DebtTypeFromJSON,
    DebtTypeFromJSONTyped,
    DebtTypeToJSON,
    DebtTypeToJSONTyped,
} from './DebtType';

/**
 * 
 * @export
 * @interface DebtRequest
 */
export interface DebtRequest {
    /**
     * 
     * @type {string}
     * @memberof DebtRequest
     */
    id?: string | null;
    /**
     * 
     * @type {DebtType}
     * @memberof DebtRequest
     */
    type: DebtType;
    /**
     * 
     * @type {string}
     * @memberof DebtRequest
     */
    value: string;
}



/**
 * Check if a given object implements the DebtRequest interface.
 */
export function instanceOfDebtRequest(value: object): value is DebtRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function DebtRequestFromJSON(json: any): DebtRequest {
    return DebtRequestFromJSONTyped(json, false);
}

export function DebtRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebtRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': DebtTypeFromJSON(json['type']),
        'value': json['value'],
    };
}

export function DebtRequestToJSON(json: any): DebtRequest {
    return DebtRequestToJSONTyped(json, false);
}

export function DebtRequestToJSONTyped(value?: DebtRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': DebtTypeToJSON(value['type']),
        'value': value['value'],
    };
}

